module.exports = __webpack_public_path__ + "img/stock1.cbe7d06f.png";